import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Tooltip, TooltipPortal } from "@animech/ui";
import * as Styled from "./node-warning.style";
import { CanvasOverlay } from "./canvas-overlay";
import { AlertIcon } from "ui/components/elements/icons/alert";
export var NodeWarning = function (_a) {
    var nodeCenterX = _a.nodeCenterX, nodeCenterY = _a.nodeCenterY, _b = _a.anchor, anchor = _b === void 0 ? "center" : _b, tooltip = _a.tooltip;
    var icon = (_jsx(Styled.NodeWarning, { anchor: anchor, interactive: Boolean(tooltip), children: _jsx(AlertIcon, { size: 18 }) }));
    return (_jsx(CanvasOverlay, { x: nodeCenterX, y: nodeCenterY, children: tooltip ? (_jsx(TooltipPortal, { anchorElement: icon, toggleEvent: "hover", placement: "top", children: _jsx(Tooltip, { css: { zIndex: 1 }, color: "neutral", children: tooltip }) })) : (icon) }));
};
